import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import { odata } from "../Filters/Helper";
import TosPaymentTableFilter from "../Filters/TosPaymentTableFilter";
import TosPaymentAddForm from "../Forms/TosPaymentAddForm";
import TosPaymentUpdateForm from "../Forms/TosPaymentUpdateForm";
import TosCreateOrderForm from "../Forms/TosCreateOrderForm";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import config from "../../util/ApiforContext";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Modal,
  Tooltip,
  notification,
  message
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SendOutlined,
  FileExcelOutlined
} from "@ant-design/icons";

const TosPayment = (props) => {
  const [loading, setLoading] = useState(false);
  const [loadingInvoiceFromLogo, setLoadingInvoiceFromLogo] = useState(false);

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 200,
    current: 1,
    filter: "&$filter=statusId eq 1",
  });
  const [order, setOrder] = useState("");
  const [addPaymentVisibility, setAddPaymentVisibility] = useState(false);
  const [updatePaymentVisibility, setUpdatePaymentVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const openNotificationWithIconExcel = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Excel indirme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };
  const [createOrderModalVisible, setCreateOrderModalVisible] = useState(false);
  const [isTosAuthorize, setIsTosAuthorize] = useState(false);

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);
  const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const [invoiceTotalAmount, setInvoiceTotalAmount] = useState(0.0);

  useEffect(() => {
    RequestHandler.get("/TenantUser/IsTosAuthorize").then((response) => {
      setIsTosAuthorize(response);
    });
  }, []);

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });
    RequestHandler.get(
      `/Payment?$count=true${filter}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
      setTotalInvoiceCount(response["@odata.count"]);
    });
    RequestHandler.get(
      `/Payment?$count=true${filter}${order}`
    ).then((response) => {
      setInvoiceTotalAmount(calculateTotal(response.value));
    });

    setTableData({
      data: tableData.data,
      total: tableData.data.length,
      loading: false,
    });
  };

  function calculateTotal(list) {
    const total = list.reduce((total, item) => total + item.amount, 0);
    return total.toFixed(2);
  }

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "&$filter=statusId eq 1",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(
      `/payment?$select=id,title,accountNumber,iban,bankId,bankBranchId,currencyId,paymentDate,description&$filter=id eq ${record.id}`
    ).then((response) => {
      const [tenant] = response.value;
      if (tenant) {
        setUpdateFormData(tenant);
        setUpdatePaymentVisibility(true);
      }
    });
    setUpdateFormData(record);
    setUpdatePaymentVisibility(true);
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/payment?id=${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddPaymentSuccess = () => {
    getTableData();
    setAddPaymentVisibility(false);
  };

  const onUpdatePaymentSuccess = () => {
    getTableData();
    setUpdatePaymentVisibility(false);
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });
  };

  const onClickCreateOrder = () => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let control = true
    selectedRows.data.forEach((t) => {
      if (new Date(t.paymentDate) < currentDate)
        control = false;
    });
    if (control)
      setCreateOrderModalVisible(true);
    else
      notification['error']({
        message: 'Hata',
        description:
          "Talimat vermek istediğiniz kayıtlarda 'Fatura Tarihi' geçmiş tarih olan kayıtlar vardır.",
        duration: 2,
      });
  };

  const onClickRemoveSelected = () => {
    RequestHandler.delete(`/payment/DeleteSelected`, selectedRows.keys).then(
      (response) => {
        if (response.success) {
          setSelectedRows({
            keys: [],
            data: [],
          });
          getTableData();
        }
      }
    );
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Ad Soyad / Ünvan",
      align: "center",
      dataIndex: "title",
    },
    {
      title: "Iban",
      align: "center",
      dataIndex: "iban",
    },
    {
      title: "Muhasebe Hesabı",
      align: 'center',
      dataIndex: "accountNo",
    },
    {
      title: "Tutar",
      align: "center",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      align: "center",
      dataIndex: "currency",
      render: (data, row) => <>TRY</>,
    },
    {
      title: "Talimat Numarası",
      align: "center",
      dataIndex: "referanceNumber",
    },
    {
      title: "Ödeme Durumu",
      align: "center",
      dataIndex: "status",
    },
    {
      title: "Durum Mesajı",
      dataIndex: "statusMessage",
    },
    {
      title: "Fatura Tarihi",
      align: "center",
      dataIndex: "paymentDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },
    {
      title: "Fatura No",
      dataIndex: "invoiceNo",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => {
        if (isTosAuthorize) {
          return (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          );
        }

        return (
          <Tooltip title="Düzenleme yetkiniz bulunmamaktadır">
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </Tooltip>
        );
      },
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, record) => {
        if (isTosAuthorize) {
          return (
            <Popconfirm
              title="Silmek istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              onConfirm={() => handleOnClickDelete(data)}
            >
              <a>
                <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
              </a>
            </Popconfirm>
          );
        }

        return (
          <Tooltip title="Silme yetkiniz bulunmamaktadır">
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </Tooltip>
        );
      },
    },
  ];

  const postInvoiceFromLogo = async () => {
    let skip = 0
    setLoadingInvoiceFromLogo(true)
    let isWhile = true
    while (isWhile) {
      await RequestHandler.post(`/Payment/InvoiceFromLogo?skip=` + skip, null,false).then((response) => {
        skip += 50
        if (!response.data)
          isWhile = false
      });
    }
    notification["success"]({
      message: "BAŞARILI",
      description: "İşlemler Başarılıdır.",
      duration: 2,
    });
    setLoadingInvoiceFromLogo(false)
    getTableData();
  };

  const exportExcel = () => {
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/Payment/ExportExcelForPaymentList`,
      { Query: filter },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        openNotificationWithIconExcel("success");
        window.open(
          `${config.apiUrl}/Payment/DownloadExcelForPaymentList?fileName=${res.data
          }&t=${RequestHandler.getToken()}`
        );
      } else {
        setLoading(false);
      }
      hide();
    });
  };

  return (
    <>
      <Row >
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> ÖDEME LİSTESİ
          </p>
        </Col>

        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Popconfirm
            title="Faturaları getirmek istediğinize emin misiniz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={postInvoiceFromLogo}
          >
            <Button
              type="primary"
              icon={<PlusOutlined />}
              style={{ marginBottom: 0 }}
              loading={loadingInvoiceFromLogo}
            >
              Faturaları Getir
            </Button>
          </Popconfirm>
          {selectedRows.keys.length > 0 && isTosAuthorize ? (
            <Popconfirm
              title="Seçilen kayıtları silmek istiyor musunuz?"
              okText="Evet"
              cancelText="Hayır"
              onConfirm={onClickRemoveSelected}
            >
              <Button
                type="danger"
                disabled={
                  selectedRows.keys.length > 0 && isTosAuthorize ? false : true
                }
                style={{ marginBottom: 0 }}
              >
                <DeleteOutlined /> Sil
              </Button>
            </Popconfirm>
          ) : (
            <Button
              type="danger"
              disabled={
                selectedRows.keys.length > 0 && isTosAuthorize ? false : true
              }
              style={{ marginBottom: 0 }}
            >
              <DeleteOutlined /> Sil
            </Button>
          )}

          <Button
            disabled={
              selectedRows.keys.length > 0 && isTosAuthorize ? false : true
            }
            onClick={onClickCreateOrder}
            style={{ marginBottom: 0 }}
          >
            <SendOutlined /> Talimat Oluştur
          </Button>
          <Button
            type="primary"
            onClick={() => {
              setAddPaymentVisibility(true);
            }}
            style={{ marginBottom: 0 }}
            disabled={!isTosAuthorize}
          >
            <PlusOutlined /> Ödeme Ekle
          </Button>
          <div style={{ display: "inline-block", verticalAlign: "middle" }}>
            <Tooltip title="Excel İndir">
              <a
                style={{
                  color: "green",
                  fontSize: "180%",
                }}
                onClick={exportExcel}
              >
                <FileExcelOutlined />
              </a>
            </Tooltip>
          </div>
        </Col>
      </Row>

      <TosPaymentTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      {
        <Row>
          <Col span={20} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Adet : {totalInvoiceCount} </p>
          </Col>
          <Col span={2} style={{ textAlign: "end", fontSize: 19 }}>
            <p>Tutar :</p>
          </Col>
          <Col span={2} style={{ fontSize: 19 }}>
            <CurrencyFormat
              value={parseFloat(invoiceTotalAmount)}
              displayType={"text"}
              decimalSeparator={","}
              thousandSeparator={"."}
            />
          </Col>
        </Row>
      }
      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={{
              selectedRowKeys: selectedRows.keys,
              onChange: onTableSelectChange,
              getCheckboxProps: () => ({
                disabled: !isTosAuthorize,
              }),
            }}
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSize: 200,
              showSizeChanger: false,
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addPaymentDrawer"
        title="Ödeme Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddPaymentVisibility(false)}
        visible={addPaymentVisibility}
      >
        <TosPaymentAddForm onSuccess={onAddPaymentSuccess} />
      </Drawer>

      <Drawer
        id="updatePaymentDrawer"
        title="Ödeme Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdatePaymentVisibility(false)}
        visible={updatePaymentVisibility}
      >
        <TosPaymentUpdateForm
          data={updateFormData}
          onSuccess={onUpdatePaymentSuccess}
        />
      </Drawer>

      <Modal
        id="createOrderModal"
        centered
        visible={createOrderModalVisible}
        onOk={() => setCreateOrderModalVisible(false)}
        onCancel={() => setCreateOrderModalVisible(false)}
        width={800}
        footer={null}
      >
        <TosCreateOrderForm
          selectedPayments={selectedRows.data}
          data={{ paymentIds: selectedRows.keys }}
        />
      </Modal>
    </>
  );
};

export default TosPayment;
